import gql from "graphql-tag";

export default gql`
  mutation Authenticate($email: String!, $password: String!) {
    authenticateUser(email: $email, password: $password) {
      id
      token
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/Authenticate.ts